// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D3sx3Jq","modal":"_5D3IFzVA"};